import React, { useState, useEffect } from 'react'

import { useAuth0 } from '@auth0/auth0-react'
import MainLogo from '../../assets/images/OP_Portal_Main_logo.svg'
import { Link } from 'react-router-dom'
import { FadeInDiv } from '../../components/Animations'
import useCookie from '../../hooks/useCookie'

const Header = () => {
    const { logout } = useAuth0()
    
    const [regCookieValue, setRegCookieValue] = useCookie('signUpPlanId')
    const [affiliateCookieValue, setAffiliateCookieValue] = useCookie('affId')

    return (
        <>
            <header>
                <div id="header-left">
                    <Link to="/dashboard">
                        <img id="logo" src={MainLogo} alt="OneProtection" />
                    </Link>
                    <div className="header-links">
                        <Link to="/account/subscription">Account</Link>
                        <Link to="/support">Support</Link>
                        <Link to="" onClick={() => {
                            setRegCookieValue('', 0)
                            setAffiliateCookieValue('', 0)
                            logout({ returnTo: window.location.origin })
                        }}>
                            Log Out
                        </Link>
                    </div>
                </div>
            </header>
        </>
    )
}

export default Header
